import '../../scss/pages/_giveaway.scss';

import dayjs from 'dayjs';
import { useState, useRef, FunctionComponent } from 'react';
import { toast } from 'react-toastify';
import { gql, useQuery } from '@apollo/client';
import IconSkinPercent from '../../scss/images/icon-skin-percent.svg';
import { Loader } from '~frontend/components/Loader';
import { useTranslation } from 'react-i18next';

const GET_PROMO_USERS = gql`
  query Giveaway($promocode: String!, $startDate: String!, $endDate: String!) {
    giveaway(promocode: $promocode, startDate: $startDate, endDate: $endDate) {
      id
      userName
      avatar
    }
  }
`;

const Giveaway: FunctionComponent = () => {
  const { t } = useTranslation();
  const [promocode, setPromocode] = useState('');
  const [startDate, setStartDate] = useState(
    dayjs().format('YYYY-MM-DD 00:00:00'),
  );
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD 23:59:59'));
  const [winner, setWinner] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const startDateInputRef = useRef(null);
  const endDateInputRef = useRef(null);

  const { data, refetch } = useQuery(GET_PROMO_USERS, {
    variables: { promocode, startDate, endDate },
    skip: true,
  });

  const handlePromocodeChange = (e) => {
    setPromocode(`${e.target.value}`.trim().toUpperCase());
  };

  const handleStartDateClick = () => {
    startDateInputRef.current.showPicker();
  };

  const handleEndDateClick = () => {
    endDateInputRef.current.showPicker();
  };

  const handleStartDateChange = (e) => {
    const formattedDate = dayjs(e.target.value).format('YYYY-MM-DD');
    setStartDate(`${formattedDate} 00:00:00`);
  };

  const handleEndDateChange = (e) => {
    const formattedDate = dayjs(e.target.value).format('YYYY-MM-DD');
    setEndDate(`${formattedDate} 23:59:59`);
  };

  const handleDraw = async () => {
    try {
      setIsLoading(true);
      const { data } = await refetch();

      setTimeout(() => {
        setIsLoading(false);
        const user = data.giveaway;
        if (user) {
          setWinner(user);
        } else {
          setWinner(undefined);
          toast.error(t('giveaway_no_users_found'), { autoClose: 3500 });
        }
      }, 500);
    } catch (error) {
      setWinner(undefined);
      toast.error(t('giveaway_fetching_error'), { autoClose: 3500 });
    }
  };

  return (
    <div className="giveaway-page">
      <div className="giveaway-title">Giveaway</div>
      <div className="giveaway-content">
        <div className="giveaway-form">
          <div className="input-gradient input-gradient-promo js-input-promo">
            <div className="icon material-icons">
              <img src={IconSkinPercent} alt="icon" />
            </div>
            <input
              placeholder={t('Promo')}
              value={promocode.toUpperCase()}
              onChange={handlePromocodeChange}
              className="js-pay-input-anim"
              type="text"
            />
          </div>
          <div className="giveaway-form-date">
            <div className="input-gradient input-gradient-promo js-input-promo">
              <div
                className="icon material-icons"
                data-icon="calendar_month"
              ></div>
              <input
                ref={startDateInputRef}
                className="js-pay-input-anim"
                type="date"
                placeholder="Start Date"
                onClick={handleStartDateClick}
                onChange={handleStartDateChange}
                value={startDate ? dayjs(startDate).format('YYYY-MM-DD') : ''}
              />
            </div>
            <div className="input-gradient input-gradient-promo js-input-promo">
              <div
                className="icon material-icons"
                data-icon="calendar_month"
              ></div>
              <input
                ref={endDateInputRef}
                className="js-pay-input-anim"
                type="date"
                placeholder="End Date"
                onChange={handleEndDateChange}
                onClick={handleEndDateClick}
                value={endDate ? dayjs(endDate).format('YYYY-MM-DD') : ''}
              />
            </div>
          </div>
          <a
            className={`btn btn-violet ${
              isLoading || !promocode ? 'disabled' : ''
            }`}
            href="#"
            onClick={handleDraw}
          >
            {t('Giveaway')}!
          </a>
        </div>
        {isLoading ? (
          <div className="giveaway-winner">
            <Loader fon={false}></Loader>
          </div>
        ) : (
          winner && (
            <div className={`giveaway-winner ${winner ? 'show' : ''}`}>
              <div className="giveaway-winner-title">{t('Winner')}</div>
              <a className="user-ava" href={`/user/${winner.id}`}>
                <img src={winner.avatar} alt="winner" />
              </a>
              <div className="user-name">{winner.userName}</div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Giveaway;
